import { render } from "./ProductStages.vue?vue&type=template&id=a03dc0a8&scoped=true&ts=true"
import script from "./ProductStages.ts?vue&type=script&lang=ts"
export * from "./ProductStages.ts?vue&type=script&lang=ts"

import "./ProductStages.scss?vue&type=style&index=0&id=a03dc0a8&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03dc0a8"]])

export default __exports__